export enum MenuApiMethods {
    createMenuCategory = "MenuCategories.CreateMenuCategory",
    deleteMenuCategory = "MenuCategories.DeleteMenuCategory",
    updateMenuCategory = "MenuCategories.UpdateMenuCategory",
    getMenuCategories = "MenuCategories.GetMenuCategories",

    menuBookingCategoriesCopyMenuBookingCategories = "MenuBookingCategories.CopyMenuBookingCategories",
    menuBookingCategoriesCreateMenuBookingCategory = "MenuBookingCategories.CreateMenuBookingCategory",
    menuBookingCategoriesDeleteMenuBookingCategory = "MenuBookingCategories.DeleteMenuBookingCategory",
    menuBookingCategoriesGetMenuBookingCategories = "MenuBookingCategories.GetMenuBookingCategories",
    menuBookingCategoriesUpdateMenuBookingCategory = "MenuCategories.UpdateMenuCategory",


    createMenuItem = "MenuItems.CreateMenuItem",
    deleteMenuItem = "MenuItems.DeleteMenuItem",
    getMenuItems = "MenuItems.GetMenuItems",
    updateMenuItem = "MenuItems.UpdateMenuItem",

    menuBookingItemsCopyMenuBookingItems = "MenuBookingItems.CopyMenuBookingItems",
    menuBookingItemsCreateMenuBookingItem = "MenuBookingItems.CreateMenuBookingItem",
    menuBookingItemsDeleteMenuBookingItem = "MenuBookingItems.DeleteMenuBookingItem",
    menuBookingItemsFindMenuBookingItems = "MenuBookingItems.FindMenuBookingItems",
    menuBookingItemsGetMenuBookingItems = "MenuBookingItems.GetMenuBookingItems",
    menuBookingItemsUpdateMenuBookingItem = "MenuBookingItems.UpdateMenuBookingItem",

    createMenu = "Menus.CreateMenu",
    deleteMenu = "Menus.DeleteMenu",
    getMenu = "Menus.GetMenu",
    getMenus = "Menus.GetMenus",
    updateMenu = "Menus.UpdateMenu",
    getStationMenu = "Menus.GetStationMenu",

    bookingMenusCreateBookingMenu = "BookingMenus.CreateBookingMenu",
    bookingMenusDeleteBookingMenu = "BookingMenus.DeleteBookingMenu",
    bookingMenusGetBookingMenu = "BookingMenus.GetBookingMenu",
    bookingMenusGetBookingMenus = "BookingMenus.GetBookingMenus",
    bookingMenusUpdateBookingMenu = "BookingMenus.UpdateBookingMenu",


    createMenuItemModifierSet = "MenuItemModifierSets.CreateMenuItemModifierSet",
    deleteMenuItemModifierSet = "MenuItemModifierSets.DeleteMenuItemModifierSet",
    getMenuItemModifierSets = "MenuItemModifierSets.GetMenuItemModifierSets",
    updateMenuItemModifierSet = "MenuItemModifierSets.UpdateMenuItemModifierSet",
    updateMenuItemModifierSetExternalSettings = "MenuItemModifierSets.UpdateMenuItemModifierSetExternalSettings",

    getTelegramReportingBindingUrl = "Menus.GetTelegramReportingBindingUrl",
    createExternalMenuIntegration = "Menus.CreateExternalMenuIntegration",
    getExternalMenuItems = "MenuItems.GetExternalMenuItems",
    updateMenuItemExternalId = "MenuItems.UpdateMenuItemExternalId",

    translateServiceTranslateText = "Translation.TranslateText",
}
